import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { requestStatuses } from '@features/absence/overview/requests-list/statuses.enum';
import { Permissions } from '@features/absence/permissions';
import { AuthService } from '@features/auth/auth.service';
import { UserRoles } from '@features/auth/user-roles';
import { TimeService } from '@services/common/time.service';
import { CrudService } from 'collection';
import { GetEntityModel } from 'collection';
import { format } from 'date-fns';
import { convertTokens, legacyParse } from '@date-fns/upgrade/v2';

@Component({
  selector: 'absence-detail-tooltip',
  templateUrl: './absence-detail-tooltip.component.html',
  styleUrls: ['./absence-detail-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AbsenceDetailTooltipComponent {
  getAbsenceGetRequest: GetEntityModel;
  loadingDay = null;
  loadingUserId = null;
  absences = [];
  requestStatuses = requestStatuses;

  @Input() date;
  @Input() item;
  @Input() user_id;
  @Input() showActionButtons: boolean = true;
  @Output() onEditClicked: EventEmitter<number> = new EventEmitter();
  @Output() onDeleteClicked: EventEmitter<number> = new EventEmitter();

  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  openMenu() {
    this.menuTrigger.openMenu();
  }

  closeMenu() {
    this.menuTrigger.closeMenu();
    this.absences = [];
  }

  click(e) {
    e.stopPropagation();
  }

  open(): void {
    const query = {
      expand: 'absenceType,user,hours',
      day: this.date,
      user_id: this.user_id
    };

    this.loadingDay = this.date;
    this.loadingUserId = this.user_id;

    this.getAbsenceGetRequest.get({ query }).subscribe((resp) => {
      this.loadingDay = null;
      this.loadingUserId = null;
      this.absences = resp.data.items.map((item) => {
        const fromDate = format(legacyParse(item.from), convertTokens('DD.MM.YYYY'));
        const toDate = format(legacyParse(item.to), convertTokens('DD.MM.YYYY'));
        const isDateSame = fromDate === toDate;

        if (isDateSame && item.duration) {
          return {
            ...item,
            formattedDuration: this._timeService.secondsToPeriod(item.duration)
          };
        }
        return item;
      });

      this._cds.markForCheck();
    });
  }

  editAbsence(absence) {
    this.onEditClicked.emit(absence);
    this.closeMenu();
  }

  deleteAbsence(absence): void {
    this.onDeleteClicked.emit(absence);
    this.closeMenu();
  }

  canDelete(): boolean {
    const currentRole = this._auth.currentRole;

    if (currentRole === UserRoles.Admin) {
      return this._auth.can(Permissions.delete);
    }

    return false;
  }

  canUpdate(): boolean {
    const currentRole = this._auth.currentRole;

    if (currentRole === UserRoles.Admin) {
      return this._auth.can(Permissions.update);
    }

    return false;
  }

  constructor(
    private _cds: ChangeDetectorRef,
    private _auth: AuthService,
    private _crud: CrudService,
    private _timeService: TimeService
  ) {
    this.getAbsenceGetRequest = this._crud.createGetEntity({ name: 'absence' });
  }
}
